import { render } from "./ElegantTemplate.vue?vue&type=template&id=872e8350&scoped=true"
import script from "./ElegantTemplate.vue?vue&type=script&lang=js"
export * from "./ElegantTemplate.vue?vue&type=script&lang=js"

import "./ElegantTemplate.vue?vue&type=style&index=0&id=872e8350&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-872e8350"]])

export default __exports__